import Header from './Header'
import './LandingPage.css'

const OurProcessPage = () => {
  /* Services dropdown state and effects moved to Header component */

  return (
    <div className="landing-page">
      <Header />

      {/* Our Process Hero Section */}
      <section className="our-process-hero-section">
        <div className="our-process-hero-content">
          <p className="our-process-hero-script">Lets Break It Down</p>
          <div className="our-process-hero-title-container">
            <h1 className="our-process-hero-headline">
              OUR BOLD WAY OF WORKING TOGETHER
              <img src="/icons BCS-18.svg" alt="Triangle icon" className="our-process-hero-headline-icon" />
            </h1>
          </div>
          <p className="our-process-hero-description">
            Here's the bold, clear-cut roadmap that takes your brand from <br /> 'just an idea' to 'unforgettable impact.'
          </p>
        </div>
      </section>

      {/* Process Steps Flowchart Section */}
      <section className="our-process-steps-section">
        {/* Snake curved dashed line background */}
        <div className="process-snake-container">
          <img src="/doted lines-02.svg" alt="" className="process-snake-line" />
        </div>

        <div className="our-process-steps-container">
          {/* Step 1: ENQUIRY - Purple */}
          <div className="our-process-step our-process-step-purple step-1">
            <div className="our-process-step-icon floating-icon-left">
              <img src="/icons BCS-35.svg" alt="Social bubble" className="our-process-icon-img" />
            </div>
            <div className="our-process-step-number">STEP 1:</div>
            <h3 className="our-process-step-title our-process-step-title-green">enquiry</h3>
            <p className="our-process-step-description">
              Fill out our enquiry form (available on our IG story highlights) or simply slide into our DMs!
            </p>
          </div>

          {/* Step 2: STRATEGY CALL - Green */}
          <div className="our-process-step our-process-step-green step-2">
            <div className="our-process-step-icon floating-icon-right">
              <img src="/icons BCS-25.svg" alt="Phone" className="our-process-icon-img" />
            </div>
            <div className="our-process-step-number">STEP 2:</div>
            <h3 className="our-process-step-title our-process-step-title-purple">STRATEGY CALL</h3>
            <p className="our-process-step-description">
              You'll get a detailed questionnaire with 25 thoughtful questions about your brand's mission, vision, and design preferences.
            </p>
          </div>

          {/* Step 3: STRATEGY & CREATIVE DIRECTION - Green */}
          <div className="our-process-step our-process-step-green step-3">
            <div className="our-process-step-icon floating-icon-top-left">
              <img src="/icons BCS-21.svg" alt="Laptop" className="our-process-icon-img" />
            </div>
            <div className="our-process-step-number">STEP 3:</div>
            <h3 className="our-process-step-title our-process-step-title-purple">STRATEGY & CREATIVE DIRECTION</h3>
            <p className="our-process-step-description">
              Using your responses + in-depth market research, we craft a brand strategy & creative direction. This includes two moodboards for you to review and approve.
            </p>
          </div>

          {/* Step 4: BRAND PRESENTATION - Purple */}
          <div className="our-process-step our-process-step-purple step-4">
            <div className="our-process-step-icon floating-icon-right-mid">
              <img src="/icons BCS-26.svg" alt="Megaphone" className="our-process-icon-img" />
            </div>
            <div className="our-process-step-number">STEP 4:</div>
            <h3 className="our-process-step-title our-process-step-title-green">BRAND PRESENTATION</h3>
            <p className="our-process-step-description">
              Once you've picked a moodboard, the magic begins! We design your visual identity and create a full brand presentation to bring your vision to life.
            </p>
          </div>

          {/* Step 5: FEEDBACK & ADD-ONS - Purple */}
          <div className="our-process-step our-process-step-purple step-5">
            <div className="our-process-step-icon floating-icon-left-bottom">
              <img src="/icons BCS-23.svg" alt="B bubble" className="our-process-icon-img" />
            </div>
            <div className="our-process-step-number">STEP 5:</div>
            <h3 className="our-process-step-title our-process-step-title-green">FEEDBACK & ADD-ONS</h3>
            <p className="our-process-step-description">
              Need revisions? We'll refine your designs as per your package. Plus, we're always happy to work on add-ons like packaging, social media templates, or PR designs!
            </p>
          </div>

          {/* Step 6: OFFBOARDING - Green */}
          <div className="our-process-step our-process-step-green step-6">
            <div className="our-process-step-icon floating-icon-top-right">
              <img src="/icons BCS-18.svg" alt="Triangle" className="our-process-icon-img" />
            </div>
            <div className="our-process-step-number">STEP 6:</div>
            <h3 className="our-process-step-title our-process-step-title-purple">OFFBOARDING</h3>
            <p className="our-process-step-description">
              It's launch time! You'll receive all your final files, PNGs, and a brand guideline to keep your visuals consistent in the future. Want ongoing digital marketing through us?
            </p>
          </div>
        </div>
      </section>

      {/* Footer Section */}
      <footer className="footer-section">
        <div className="footer-wavy-top">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 100" preserveAspectRatio="none" className="wavy-svg wavy-green-2">
            <path d="M0,50 Q60,20 120,50 T240,50 T360,50 T480,50 T600,50 T720,50 T840,50 T960,50 T1080,50 T1200,50 T1320,50 T1440,50 L1440,100 L0,100 Z" fill="#CDD951" />
          </svg>
        </div>
        <div className="footer-star-icon">
          <img src="/icons BCS-44.svg" alt="Star icon" className="footer-star-icon-img" />
        </div>
        <div className="footer-content">
          <div className="footer-logo">
            <img src="/BCS%20LOGO-01%20(1).png" alt="BOLD! CREATIVE STUDIO" className="footer-logo-img" />
          </div>
          <div className="footer-social-icons">
            <a href="https://www.instagram.com/brandingoutloud/" target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label="Instagram">
              <img src="/WEBSITE IMAGES-17.svg" alt="Instagram" className="footer-social-icon-img" />
            </a>
            <a href="https://www.behance.net/brandingoutloud?utm_source=ig&utm_medium=social&utm_content=link_in_bio&fbclid=PAZXh0bgNhZW0CMTEAc3J0YwZhcHBfaWQMMjU2MjgxMDQwNTU4AAGnHFYMm_3Cc_qOoIHo5M7pIpJVh1fw7yG_MjUWcetV-lC7sxbyqLSp49vJ22Y_aem_NaED6HYtWH8rqyuMagDYig" target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label="Behance">
              <img src="/WEBSITE IMAGES-18.svg" alt="Behance" className="footer-social-icon-img" />
            </a>
            <a href="https://www.linkedin.com/company/brandingoutloud/" target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label="LinkedIn">
              <div className="footer-social-icon-img" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#594F9A', borderRadius: '50%', transform: 'scale(0.75)' }}>
                <svg viewBox="0 0 24 24" fill="white" style={{ width: '24px', height: '24px', margin: 0 }}>
                  <path d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z"/>
                </svg>
              </div>
            </a>
            <a href="https://www.facebook.com/share/1879QvWrk8/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label="Facebook">
              <img src="/WEBSITE IMAGES-19.svg" alt="Facebook" className="footer-social-icon-img" />
            </a>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default OurProcessPage



